import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import InstallPwaButton from "@/components/InstallPwaButton";
import OfflineQueueIndicator from "@/components/OfflineQueueIndicator";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Submit from "@/pages/Submit";
import Confirmation from "@/pages/Confirmation";
import Wall from "@/pages/Wall";
import Story from "@/pages/Story";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminRedeem from "@/pages/AdminRedeem";
import AdminStoreQR from "@/pages/AdminStoreQR";
import AdminWallQR from "@/pages/AdminWallQR";
import AdminLeaderboard from "@/pages/AdminLeaderboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/submit" element={<Submit />} />
            <Route path="/thanks/:id" element={<Confirmation />} />
            <Route path="/wall" element={<Wall />} />
            <Route path="/story/:id" element={<Story />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/redeem"
              element={
                <ProtectedRoute>
                  <AdminRedeem />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/store-qr"
              element={
                <ProtectedRoute>
                  <AdminStoreQR />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/wall-qr"
              element={
                <ProtectedRoute>
                  <AdminWallQR />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/leaderboard"
              element={
                <ProtectedRoute>
                  <AdminLeaderboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <InstallPwaButton />
        <OfflineQueueIndicator />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
